// Routes ///////////////////////////////////////////////////////////////
export const FundamentalAnalysisRoute = (
  security?: string,
  fundamentalId?: number | string,
): string =>
  `/fundamental/analysis${security ? `/?security=${security}` : ''}${
    fundamentalId ? `&fundamentalId=${fundamentalId.toString()}` : ''
  }`;

export const FundamentalWatchRoute = (): string => `/fundamental/watch`;

// API //////////////////////////////////////////////////////////////////

export const FundamentalUrl = (
  security: string,
  fundamentalId?: number | string,
): string =>
  !fundamentalId
    ? `/api/v1/fundamentals/analysis/${security}/`
    : `/api/v1/fundamentals/analysis/${security}${`/?fundamental_id=${fundamentalId}`}`;

export const FundamentalPDFDownloadUrl = (
  security: string | number,
  type: string,
  fundamentalId,
): string =>
  // this two tab are common with export data and their URL request is different
  `/api/v1/common/download/pdf/${security}/${type}/?fundamental_id=${fundamentalId}`;

export const FundamentalWatchUrl = (): string => `/api/v1/fundamentals/watch/`;
export const FundamentalEpsUrl = (): string => `/api/v1/fundamentals/eps/`;
